import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_21: FaireProductEntity = {
  token: "catalog_prod_prod-21",
  type: "product",
  name: "Celebration Banner - Happy Everything - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 20.08,
  msrpDollars: 50.2,
  sku: "CO0021",
  caseSize: 3,
  material: "Cotton",
  collectionToken: "col_confetti-cake",
  categoryTokens: ["catalog_cat_makeup"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 434,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
